export const getVideoSdkUcCode = (plan_code, quantity) => `${plan_code}$${quantity}`;
export const parseVideoSdkUcCode = (cPlanCode) => {
  const [plan_code, quantity] = cPlanCode.split('$');
  return {
    plan_code,
    quantity,
  };
};
